import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

export function initiatorHeaderInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    const requestWithInitiatorHeader = req.clone({
        headers: req.headers.set('x-hedgeserv-initiator', 'nqs'),
    });
    return next(requestWithInitiatorHeader);
}
